import {
    WASTAGE_SAVE,
    WASTAGE_SAVE_SUCCESS,
    WASTAGE_SAVE_FAIL,

    WASTAGE_FILTER,
    WASTAGE_FILTER_SUCCESS,
    WASTAGE_FILTER_FAIL,

    WASTAGE_SINGLE_GET,
    WASTAGE_SINGLE_GET_SUCCESS,
    WASTAGE_DELETE,
    WASTAGE_DELETE_SUCCESS,
    WASTAGE_UPDATE_SUCCESS,
    WASTAGE_UPDATE,
    WASTAGE_UPDATE_FAIL,
    WASTAGE_DELETE_FAIL,
    WASTAGE_EXCEL_REPORT_SUCCESS,
    WASTAGE_EXCEL_REPORT,
    WASTAGE_EXCEL_REPORT_FAIL
} from "./actionType";

const INIT_STATE = {
    loading: false,

    saveResponse: null,
    filterList: [],
    editData: { Status: false },
    updateMsg: { Status: false },
    deleteMsg: { Status: false },
    singleData: null,
    deleteResponse: null,
    listBtnLoading: false,
    excelData: [],           // 🔥 NEW
    excelBtnLoading: false,  // 🔥 NEW
    error: null,
};

const wastageReducer = (state = INIT_STATE, action) => {
    switch (action.type) {

        /* ========== REQUEST ========== */
        case WASTAGE_SAVE:
        case WASTAGE_FILTER:
            return {
                ...state,
                loading: true,
                error: null,
            };

        /* ========== SAVE ========== */
        case WASTAGE_SAVE_SUCCESS:
            return {
                ...state,
                loading: false,
                saveResponse: action.payload, // 🔥 REQUIRED
            };

        case WASTAGE_SAVE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        /* ========== FILTER ========== */
        case WASTAGE_FILTER_SUCCESS:
            return {
                ...state,
                loading: false,
                filterList: action.payload,
            };

        case WASTAGE_FILTER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        /* ========== SINGLE GET ========== */
        case WASTAGE_SINGLE_GET:
            return {
                ...state,
                editData: { Status: false }, // ✅ RESET BEFORE CALL
                listBtnLoading: action.config?.btnId || false,
            };

        case WASTAGE_SINGLE_GET_SUCCESS:
            return {
                ...state,
                editData: action.payload,
                listBtnLoading: false,
            };
        case WASTAGE_UPDATE:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case WASTAGE_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                updateMsg: action.payload,
                editData:
                    action.payload?.Status === true &&
                        action.payload?.StatusCode === 200
                        ? { Status: false }
                        : state.editData,
            };

        case WASTAGE_DELETE:
            return {
                ...state,
                listBtnLoading: true,
            }
        case WASTAGE_DELETE_SUCCESS:
            return {
                ...state,
                deleteMsg: action.payload,
                filterList: state.filterList.filter(
                    item => item.id !== action.payload.deletedId
                ),
                listBtnLoading: false,
            }
        case WASTAGE_UPDATE_FAIL:
            return {
                ...state,
                loading: false,        // ✅ STOP SAVE/UPDATE LOADER
                error: action.payload,
            };

        case WASTAGE_DELETE_FAIL:
            return {
                ...state,
                listBtnLoading: false, // ✅ STOP DELETE LOADER
                error: action.payload,
            };

        case WASTAGE_EXCEL_REPORT:
            return {
                ...state,
                excelBtnLoading: true,
                error: null,
            };

        case WASTAGE_EXCEL_REPORT_SUCCESS:
            return {
                ...state,
                excelBtnLoading: false,
                excelData: action.payload,
            };

        case WASTAGE_EXCEL_REPORT_FAIL:
            return {
                ...state,
                excelBtnLoading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default wastageReducer;
